import type { ComponentProps } from 'react';

import type { AccountNo } from '../account-no/AccountNo';

export interface BankConnection {
    iban?: string | null;
    accountNumber?: string | null;
    prefix?: string | null;
    bankCode?: string | null;
    bic?: string | null;
    countryCode?: string | null;
    country?: string | null;
}

type Account = ComponentProps<typeof AccountNo>['account'];

export function mapBankConnectionToAccount(bankConnection?: BankConnection | null): Account {
    return {
        iban: bankConnection?.iban ?? undefined,
        number: bankConnection?.accountNumber ?? undefined,
        prefix: bankConnection?.prefix ?? undefined,
        bankCode: bankConnection?.bankCode ?? undefined,
        bic: bankConnection?.bic ?? undefined,
        countryCode: bankConnection?.countryCode ?? bankConnection?.country ?? undefined,
    };
}
